<ng-container *ngIf="!openInModal">
  <app-three-sixty-viewer-core
    [images]="images"
    [minimal]="false"
    (openEmitter)="openModal()"
  ></app-three-sixty-viewer-core>
</ng-container>

<nz-modal
  [(nzVisible)]="isModalVisible"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzWidth]="'100vw'"
  [nzStyle]="{ top: '0', padding: 0, background: 'black' }"
  [nzBodyStyle]="{ padding: '0', height: '100vh', overflow: 'hidden' }"
  (nzAfterOpen)="onModalAfterOpen()"
>
  <app-three-sixty-viewer-modal-body
    [images]="images"
    [init]="modalInitialized"
    (closeEmitter)="closeModal()"
  ></app-three-sixty-viewer-modal-body>
</nz-modal>
